export default __webpack_public_path__ + "waveWorker.min.js";